document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains('template-product')) {
    const button = document.getElementById("toggle-button");

    if (button) {
      const mehrContent = document.getElementById("mehr-content");
      
      mehrContent.style.height = "0";
      mehrContent.style.overflow = "hidden";
      mehrContent.style.transition = "height 0.3s ease";

      function toggleMehr() {
        if (mehrContent.style.height === "0px" || mehrContent.style.height === "0") {
          mehrContent.style.height = mehrContent.scrollHeight + "px";
          button.innerHTML = 'Weniger anzeigen <span class="chevron">&#9650;</span>';
        } else {
          mehrContent.style.height = "0";
          button.innerHTML = 'Weiterlesen <span class="chevron">&#9660;</span>';
        }
      }

      button.addEventListener("click", toggleMehr);
    }
  }
});
